module.exports = __webpack_public_path__ + "static/NN-logo-f8cc2cfd16528e7156cee5afa302c8b9.png";